import { Box } from "@mui/material";
import { DayAndDatePicker, DaymapIcon, DaymapIconType, useStudent, useAppState } from "daymap-react";
import { useParams } from "react-router-dom";
import { PageContainer, PageDescriptor } from "../../../components/layout";
import { EventsForDays } from "../../../components/diary";

type TimetableForm = {
    date: Date;
}

function Timetable() {
    const {studentId} = useParams();
    const student = useStudent(Number(studentId));
    const [ state, setViewState ] = useAppState<TimetableForm>("TimetableForm", { date: new Date() }, "session");
    
    const { date } = state;

    const updateDate = (newDate?: Date) => {
        if (Boolean(newDate)) {
            newDate!.setHours(0, 0, 0, 0);
            setViewState({ date: newDate! });
        }
    }

    return <PageContainer>
        <PageDescriptor icon={<DaymapIcon iconType={DaymapIconType.Schedule} />} title="Timetable">
            View {student?.Displayname}'s timetable for the selected day
        </PageDescriptor>
        <DayAndDatePicker selectedDate={date} onChange={updateDate} />
        <Box sx={{ display: 'flex', flexFlow: 'column', gap: 1 }}>
            <EventsForDays date={date} studentId={Number(studentId)} hideStudentChip />
        </Box>
    </PageContainer>
}

export default Timetable;